import { render, staticRenderFns } from "./InputDropdown.vue?vue&type=template&id=6206db1b&scoped=true&"
import script from "./InputDropdown.vue?vue&type=script&lang=js&"
export * from "./InputDropdown.vue?vue&type=script&lang=js&"
import style0 from "./InputDropdown.vue?vue&type=style&index=0&id=6206db1b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6206db1b",
  null
  
)

export default component.exports